import { SxProps, Theme } from "@mui/material";

export const feedbackButtonContainerSx = (
  right: number | string,
  bottom: number | string,
  position: "fixed" | "absolute" | "static" = "fixed",
): SxProps<Theme> => ({
  position,
  ...(position === "static"
    ? {}
    : {
        right,
        bottom,
        transform: {
          xs: "translateY(4px)",
          sm: "translateY(-5px)",
          md: "translate(8px, 1px)",
        },
      }),
  zIndex: 50,
});

export const feedbackIconButtonSx =
  (forceLarge = false): SxProps<Theme> =>
  (theme: Theme) => ({
    width: forceLarge ? 48 : 44,
    height: forceLarge ? 48 : 44,
    borderRadius: "50%",
    backgroundColor: "transparent",
    border: "none",
    boxShadow: "none",
    transition: "transform 0.2s ease",
    "&:hover": {
      backgroundColor: "transparent",
      transform: "scale(1.03)",
    },
    "&.Mui-disabled": {
      opacity: 0.45,
      cursor: "not-allowed",
    },
    "& svg": {
      width: forceLarge ? 40 : 36,
      height: forceLarge ? 40 : 36,
    },
    ...(forceLarge
      ? {}
      : {
          [theme.breakpoints.between("sm", "md")]: {
            width: 44,
            height: 44,
            "& svg": {
              width: 36,
              height: 36,
            },
          },
          [theme.breakpoints.up("lg")]: {
            width: 56,
            height: 56,
            "& svg": {
              width: 46,
              height: 46,
            },
          },
        }),
  });
